// extracted by mini-css-extract-plugin
export default {"card":"card_card__bKM7J","cardImg":"card_cardImg__0wxEd","cardText":"card_cardText__9sDnb","cardDate":"card_cardDate__2jFDE"};